import { formatCostAsNumber } from '@format/currency';
import { calculateGrandTotals } from '../CheckoutConfirmationContainer/dataParsers';
import { ADDON_PRODUCT_TYPES_LIST } from '../constants';

export const formatPhoneNumber = phoneNumber => {
  const withCountryCode = '1' + phoneNumber;

  const formattedPhoneNumber = withCountryCode.replace(/-/g, '');

  return formattedPhoneNumber;
};

export const formatCheckoutPurchasedData = orders => {
  const { orderTotal, totalPrice, discountAmount } =
    calculateGrandTotals(orders);
  const customerInfo = {
    first_name: orders[0].customer.first_name,
    last_name: orders[0].customer.last_name,
    id: orders[0].customer.id,
    email: orders[0].customer.email,
    phone_number: formatPhoneNumber(orders[0].customer.phone_number),
  };
  const couponCode = orders[0].coupon_code;
  const ordersData = orders.map(order => {
    const petItem = order.items.find(item => item.pet_id);
    let addons_price = 0;
    const addons = order.items
      .filter(item => ADDON_PRODUCT_TYPES_LIST.includes(item.product_type))
      .map(addon => {
        addons_price += parseFloat(addon.price) * addon.quantity;
        return {
          sku: addon.sku,
          quantity: addon.quantity,
          price: addon.price,
        };
      });

    const { address1, address2, city, state, zip_code } = order.address;
    const street_address = address1 + ' ' + address2;

    return {
      id: order.id,
      order_price: order.subtotal_ex_tax,
      mealplan_price: petItem.price,
      addons_price: addons_price.toFixed(2),
      discount_code: order.coupon_code,
      discount_amount: order.total_discount,
      total_price: order.total_price,
      street_address,
      sku: petItem.sku,
      zip: zip_code,
      state: state,
      city: city,
      addons: addons,
    };
  });

  return {
    order_details: {
      order_price: orderTotal,
      discount_amount: discountAmount,
      discount_code: couponCode,
      total_price: Number(totalPrice.slice(1)),
      currency: 'USD',
      customer_info: customerInfo,
      orders: ordersData,
    },
  };
};

export const formatCompletedOrderData = orders => {
  const { discountAmount, subtotal, totalTax } = calculateGrandTotals(orders);
  const couponCode = orders[0].coupon_code;

  const getItemCategory = (recipes = { dry: [], fresh: [] }) => {
    return recipes.dry.length && recipes.fresh.length
      ? 'mixed'
      : recipes.dry.length
      ? 'dry'
      : 'fresh';
  };
  const productDetails = orders.map(order => {
    const petItem = order.items.find(item => item.pet_id);
    return {
      order_id: order.id,
      product_id: order.subscription_id, // Adding this per ES-201 https://ollie.atlassian.net/browse/ES-201
      id: petItem.pet_id,
      sku: petItem.sku,
      name: petItem.pet_name,
      price: petItem.price,
      quantity: petItem.quantity,
      category: getItemCategory(petItem.recipes),
    };
  });

  const addonsDetails = orders.flatMap(order =>
    order.items
      .filter(addon => ADDON_PRODUCT_TYPES_LIST.includes(addon.product_type))
      .map(addon => ({
        order_id: order.id,
        product_id: order.subscription_id,
        id: addon.pet_id,
        sku: addon.sku,
        name: addon.pet_name,
        price: addon.price,
        quantity: addon.quantity,
        category: addon.product_type,
      })),
  );

  return {
    subtotal: formatCostAsNumber(subtotal),
    revenue: formatCostAsNumber(subtotal),
    tax: totalTax === '' ? 0 : formatCostAsNumber(totalTax),
    discount: formatCostAsNumber(discountAmount),
    coupon: couponCode,
    currency: 'USD',
    products: [...productDetails, ...addonsDetails],
  };
};
